import { Achievement } from "@onmo/graphql/graphql";

export const setPreviousGzCoin = (gzCoin: number) => {
  sessionStorage.setItem("previousGzCoin", JSON.stringify(gzCoin));
};

export const getPreviousGzCoin = (): number | null => {
  const previousGzCoin = sessionStorage.getItem("previousGzCoin");
  return previousGzCoin ? JSON.parse(previousGzCoin) : null;
};

export const clearPreviousGzCoin = () => {
  sessionStorage.removeItem("previousGzCoin");
};

export const setPreviousAchievements = (achievements: Achievement[]) => {
  sessionStorage.setItem("previousAchievements", JSON.stringify(achievements));
};

export const getPreviousAchievements = (): Achievement[] | null => {
  const previousAchievements = sessionStorage.getItem("previousAchievements");
  return previousAchievements ? JSON.parse(previousAchievements) : null;
};

export const clearPreviousAchievements = () => {
  sessionStorage.removeItem("previousAchievements");
};
